import store from '@/store/index';

export default store;



// WEBPACK FOOTER //
// ./products/390/store/index.js